/* eslint-disable */

import moment from 'moment';
import querystring from 'querystring';
import log from '@/logger';
import store from '@/store';
import ls from '@/helpers/localStorage';

let refreshSubscribers = [];
let isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(cb => cb(token));
  refreshSubscribers = [];
}

const skipFromInterceptor = [
  'api/Account/UploadUserImage',
  'api/Support/Ticket',
  'api/Profile/SetUserAffiliations',
  'api/Profile/RemoveUserAffiliations',
  `${process.env.REAL_API_URL}api/Account/UploadUserImage`,
  `${process.env.REAL_API_URL}api/Support/Ticket`,
  `${process.env.REAL_API_URL}api/Profile/SetUserAffiliations`,
  `${process.env.REAL_API_URL}api/Profile/RemoveUserAffiliations`
];

function checkRequest(request) {
  return request.method === 'post' && skipFromInterceptor.indexOf(request.url) === -1;
}

export default (request) => {
  if (checkRequest(request)) {
    request.data = querystring.stringify(request.data);
  }
  if (!store.getters['user/isLoggedIn']) return request;

  const expiresAt = ls.get('tokenExpires', null);
  const threshold = -60;
  const expiresOrIsAboutToExpires = (expiresAt === null || moment().diff(moment(expiresAt), 'seconds') > threshold);

  if (expiresOrIsAboutToExpires && !isRefreshing) {
    isRefreshing = true;
    const payload = {
      grant_type: 'refresh_token',
      refresh_token: ls.get('refreshToken'),
    };
    store.dispatch('user/login', payload)
      .then(() => {
        isRefreshing = false;
        log.info('[TOKEN] REFRESHED');
        tokenRefreshComplete(ls.get('token'));
      })
      .catch(() => {
        log.info('[TOKEN] CANNOT REFRESH');
        store.dispatch('user/setToken', null);
      });

    return new Promise((resolve) => {
      tokenRefreshSubscribe((token) => {
        request.headers.Authorization = `Bearer ${token}`;
        log.info('[TOKEN] Retry');
        resolve(request);
      });
    });
  }

  return request;
};



// WEBPACK FOOTER //
// ./src/services/interceptors/request.js